import { ComponentType } from '@angular/cdk/overlay';
import { BaseIconComponent } from 'src/app/ui-kit/icons/base-icon.component';
import { CarIconComponent } from 'src/app/ui-kit/icons/car-icon.component';
import { CartwheelIconComponent } from 'src/app/ui-kit/icons/cartwheel-icon.component';
import { DogIconComponent } from 'src/app/ui-kit/icons/dog-icon.component';
import { MinimalistHouseIconComponent } from 'src/app/ui-kit/icons/house-minimalist-icon.component';
import { SimpleHouseIconComponent } from 'src/app/ui-kit/icons/house-simple-icon.component';
import { JewelryIconComponent } from 'src/app/ui-kit/icons/jewelry-icon.component';
import { KeyIconComponent } from 'src/app/ui-kit/icons/key-icon.component';
import { PlaneIconComponent } from 'src/app/ui-kit/icons/plane-icon.component';

import { InsuranceTypeEnum } from '../insurance-type.enum';

export enum ClaimType {
  TRAVEL = InsuranceTypeEnum.TRAVEL,
  BUILDING = InsuranceTypeEnum.BUILDING,
  RC_HOUSEHOLD = InsuranceTypeEnum.RC_HOUSEHOLD,
  LEGAL_PROTECTION = InsuranceTypeEnum.LEGAL_PROTECTION,
  MOTOR_VEHICLE = InsuranceTypeEnum.MOTOR_VEHICLE,
  ANIMAL = InsuranceTypeEnum.ANIMAL,
  VALUABLE_OBJECTS = InsuranceTypeEnum.VALUABLE_OBJECTS,
  CONSTRUCTION = InsuranceTypeEnum.CONSTRUCTION,
  BUSINESS_ACCIDENT = InsuranceTypeEnum.BUSINESS_ACCIDENT,
  BUSINESS_HEALTH = InsuranceTypeEnum.BUSINESS_HEALTH,
  BUSINESS_RC_COMPANY = InsuranceTypeEnum.BUSINESS_RC_COMPANY,
  BUSINESS_COMPANY_THINGS = InsuranceTypeEnum.BUSINESS_COMPANY_THINGS,
  BUSINESS_MOTOR_VEHICLE = InsuranceTypeEnum.BUSINESS_MOTOR_VEHICLE,
  BUSINESS_RETIREMENT = InsuranceTypeEnum.BUSINESS_RETIREMENT,
  BUSINESS_LEGAL_PROTECTION = InsuranceTypeEnum.BUSINESS_LEGAL_PROTECTION,
  BUSINESS_BUILDING = InsuranceTypeEnum.BUSINESS_BUILDING,
  BUSINESS_CONSTRUCTION = InsuranceTypeEnum.BUSINESS_CONSTRUCTION,
  BUSINESS_TRANSPORT = InsuranceTypeEnum.BUSINESS_TRANSPORT,
  BUSINESS_CYBERSECURITY = InsuranceTypeEnum.BUSINESS_CYBERSECURITY,
  BUSINESS_TECHNICAL_INSTALLATION = InsuranceTypeEnum.BUSINESS_TECHNICAL_INSTALLATION,
  BUSINESS_FLEET = InsuranceTypeEnum.BUSINESS_FLEET,
  ACCIDENT = InsuranceTypeEnum.ACCIDENT,
  HEALTH_ALLOWANCE = InsuranceTypeEnum.HEALTH_ALLOWANCE,
}

export type PersonalClaimType =
  | ClaimType.TRAVEL
  | ClaimType.BUILDING
  | ClaimType.RC_HOUSEHOLD
  | ClaimType.LEGAL_PROTECTION
  | ClaimType.MOTOR_VEHICLE
  | ClaimType.ANIMAL
  | ClaimType.VALUABLE_OBJECTS
  | ClaimType.CONSTRUCTION;

export type BusinessClaimType =
  | ClaimType.BUSINESS_ACCIDENT
  | ClaimType.BUSINESS_HEALTH
  | ClaimType.BUSINESS_RC_COMPANY
  | ClaimType.BUSINESS_COMPANY_THINGS
  | ClaimType.BUSINESS_MOTOR_VEHICLE
  | ClaimType.BUSINESS_RETIREMENT
  | ClaimType.BUSINESS_LEGAL_PROTECTION
  | ClaimType.BUSINESS_BUILDING
  | ClaimType.BUSINESS_CONSTRUCTION
  | ClaimType.BUSINESS_TRANSPORT
  | ClaimType.BUSINESS_CYBERSECURITY
  | ClaimType.BUSINESS_TECHNICAL_INSTALLATION;

export const getClaimTypeLabel = (type: ClaimType): string => {
  switch (type) {
    case ClaimType.TRAVEL:
      return $localize`Voyage`;
    case ClaimType.BUILDING:
      return $localize`Bâtiment`;
    case ClaimType.RC_HOUSEHOLD:
      return $localize`RC ménage`;
    case ClaimType.LEGAL_PROTECTION:
      return $localize`Protection juridique`;
    case ClaimType.MOTOR_VEHICLE:
      return $localize`Véhicule à moteur`;
    case ClaimType.ANIMAL:
      return $localize`Animal`;
    case ClaimType.VALUABLE_OBJECTS:
      return $localize`Objet de valeur`;
    case ClaimType.CONSTRUCTION:
      return $localize`Construction`;
    case ClaimType.BUSINESS_ACCIDENT:
      return $localize`LAA`;
    case ClaimType.BUSINESS_HEALTH:
      return $localize`Perte de gain`;
    case ClaimType.BUSINESS_RC_COMPANY:
      return $localize`RC entreprise`;
    case ClaimType.BUSINESS_COMPANY_THINGS:
      return $localize`Choses entreprise`;
    case ClaimType.BUSINESS_MOTOR_VEHICLE:
      return $localize`Véhicule à moteur entreprise`;
    case ClaimType.BUSINESS_RETIREMENT:
      return $localize`LPP`;
    case ClaimType.BUSINESS_LEGAL_PROTECTION:
      return $localize`Protection juridique entreprise`;
    case ClaimType.BUSINESS_BUILDING:
      return $localize`Bâtiment entreprise`;
    case ClaimType.BUSINESS_CONSTRUCTION:
      return $localize`Construction entreprise`;
    case ClaimType.BUSINESS_TRANSPORT:
      return $localize`Transport`;
    case ClaimType.BUSINESS_CYBERSECURITY:
      return $localize`Cybersécurité`;
    case ClaimType.BUSINESS_TECHNICAL_INSTALLATION:
      return $localize`Installation technique`;
    case ClaimType.BUSINESS_FLEET:
      return $localize`Flotte`;
    case ClaimType.ACCIDENT:
      return $localize`Accident privé`;
    case ClaimType.HEALTH_ALLOWANCE:
      return $localize`IJM privé`;
    default:
      return '';
  }
};

export const getClaimTypeIcon = (type: ClaimType): ComponentType<BaseIconComponent> => {
  switch (type) {
    case ClaimType.TRAVEL:
      return PlaneIconComponent;
    case ClaimType.BUILDING:
      return SimpleHouseIconComponent;
    case ClaimType.RC_HOUSEHOLD:
      return CartwheelIconComponent;
    case ClaimType.LEGAL_PROTECTION:
      return KeyIconComponent;
    case ClaimType.MOTOR_VEHICLE:
      return CarIconComponent;
    case ClaimType.ANIMAL:
      return DogIconComponent;
    case ClaimType.VALUABLE_OBJECTS:
      return JewelryIconComponent;
    case ClaimType.CONSTRUCTION:
      return MinimalistHouseIconComponent;
    default:
      return null;
  }
};

export const isPersonalClaim = (type: ClaimType) =>
  type === ClaimType.TRAVEL ||
  type === ClaimType.BUILDING ||
  type === ClaimType.RC_HOUSEHOLD ||
  type === ClaimType.LEGAL_PROTECTION ||
  type === ClaimType.MOTOR_VEHICLE ||
  type === ClaimType.ANIMAL ||
  type === ClaimType.VALUABLE_OBJECTS ||
  type === ClaimType.CONSTRUCTION ||
  type === ClaimType.ACCIDENT ||
  type === ClaimType.HEALTH_ALLOWANCE;
